import { dew as _toBytesDew } from "../encoding/toBytes.js";
import { dew as _toHexDew } from "../encoding/toHex.js";
import { dew as _keccakDew } from "../hash/keccak256.js";
import { dew as _encodedLabelToLabelhashDew } from "./encodedLabelToLabelhash.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.labelhash = void 0;
  const toBytes_js_1 = _toBytesDew();
  const toHex_js_1 = _toHexDew();
  const keccak256_js_1 = _keccakDew();
  const encodedLabelToLabelhash_js_1 = _encodedLabelToLabelhashDew();
  function labelhash(label) {
    const result = new Uint8Array(32).fill(0);
    if (!label) return (0, toHex_js_1.bytesToHex)(result);
    return (0, encodedLabelToLabelhash_js_1.encodedLabelToLabelhash)(label) || (0, keccak256_js_1.keccak256)((0, toBytes_js_1.stringToBytes)(label));
  }
  exports.labelhash = labelhash;
  //# sourceMappingURL=labelhash.js.map
  return exports;
}